export default __webpack_public_path__ + "static/media/chef.893353cc.svg";